<ng-container *ngIf="vm$ | async as vm">
  <div
    class="connectivity-wrapper"
    *ngIf="vm.visible || retryInFlight"
    [@connectivityOverlay]
    [class.under-splash]="underSplash"
  >
    <div class="connectivity-backdrop"></div>

    <div
      class="connectivity-container"
      [class.connectivity-container--shake]="showRetryShake"
      (click)="$event.stopPropagation()"
    >
      <ng-container *ngIf="vm.checking || retryInFlight">
        <div class="connectivity-icon-wrap">
          <ion-spinner name="crescent" class="connectivity-spinner"></ion-spinner>
        </div>
        <h3 class="connectivity-title">
          {{ "CONNECTIVITY_CHECKING" | translate }}
        </h3>
      </ng-container>

      <ng-container *ngIf="vm.offline && !retryInFlight && !vm.checking">
        <div class="connectivity-icon-wrap">
          <ion-icon
            name="cloud-offline-outline"
            class="connectivity-icon"
          ></ion-icon>
        </div>
        <h3 class="connectivity-title">
          {{ "CONNECTIVITY_ISSUE_TITLE" | translate }}
        </h3>
        <p class="connectivity-message">
          {{ "CONNECTIVITY_ISSUE_SUBTITLE" | translate }}
        </p>
        <div class="connectivity-actions">
          <app-btn
            [text]="'RETRY_CONNECTIVITY' | translate"
            type="primary"
            icon="refresh-outline"
            (clicked)="onRetry()"
          ></app-btn>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
